import view from './view.vue'

export default {
	view
}